<template>
  <v-row class="mx-3 d-flex mb-1 ">
    <v-expand-transition>
      <span
        v-if="mostrarMensagemDeEnvioDosAnexos"
        class="mx-3"
      >
        Enviado com sucesso.
      </span>
    </v-expand-transition>

    <v-card
      v-for="(item, index) in listaDeAnexos"
      :key="index"
      class="ma-4 bg-grey-darken d-flex "
      height="50"
    >
      <div>
        <v-icon
          size="20"
          class="m-auto"
          :disabled="loading"
          @click="removerAnexo(item)"
        >
          {{ icons.mdiClose }}
        </v-icon>
      </div>

      <v-progress-circular
        v-if="loading"
        class="mt-2 ma-2"
        outlined
        indeterminate
        color="primary"
      />

      <v-img
        v-else
        class="rounded cursor-pointer"
        width="50"
        height="50"
        cover
        :aspect-ratio="1"
        :src="item.dataUrl"
        @click="visualizarImg(item)"
      />
    </v-card>
  </v-row>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiClose } from '@mdi/js'

export default {
  props: {
    mostrarMensagemDeEnvioDosAnexos: Boolean,
    loading: Boolean,
    listaDeAnexos: {
      type: Array,
      required: true,
    },
    removerAnexo: {
      type: Function,
      required: true,
    },
  },

  setup() {
    const link = ref('')

    function visualizarImg(item) {
      const parts = item.dataUrl.split(';base64,')
      const imageType = parts[0].split(':')[1]
      const decodedData = window.atob(parts[1])
      const uInt8Array = new Uint8Array(decodedData.length)
      for (let i = 0; i < decodedData.length; i += 1) {
        uInt8Array[i] = decodedData.charCodeAt(i)
      }
      link.value = new Blob([uInt8Array], { type: imageType })
      link.value = URL.createObjectURL(link.value)
      window.open(`${link.value}`)
    }

    return {
      link,
      visualizarImg,
      icons: {
        mdiClose,
      },
    }
  },
}
</script>
